<button type="button" class="window-control" aria-label="Minimize" title="Minimize" (click)="onMinimize()">
  <svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true" focusable="false">
    <path d="M0 5.5h10" />
  </svg>
</button>

<button
  type="button"
  class="window-control"
  [attr.aria-label]="isMaximized() ? 'Restore down' : 'Maximize'"
  [title]="isMaximized() ? 'Restore down' : 'Maximize'"
  (click)="onToggleMaximize()">
  <svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true" focusable="false">
    @if (isMaximized()) {
      <path d="M2.5 2.5v-2h7v7h-2" />
      <path d="M0.5 2.5h7v7h-7z" />
    } @else {
      <path d="M0.5 0.5h9v9h-9z" />
    }
  </svg>
</button>

<button type="button" class="window-control window-control--close" aria-label="Close" title="Close" (click)="onClose()">
  <svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true" focusable="false">
    <path d="M0.5 0.5l9 9M9.5 0.5l-9 9" />
  </svg>
</button>
